import React, { Component } from 'react';
import styles from './ModalControls.module.css';

class ModalControls extends Component {
  constructor(props) {
    super(props);

    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleKeyboardEvent = this.handleKeyboardEvent.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyboardEvent);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyboardEvent);
  }

  handleKeyboardEvent(event) {
    const { onNavigate, posts, currentItem } = this.props;
    if (event.keyCode === 39 || event.keyCode === 37) {
      event.stopImmediatePropagation();
      event.preventDefault();
      onNavigate(event.keyCode === 39, posts, currentItem);
    }

    return false;
  }

  handlePreviousClick() {
    const { onNavigate, posts, currentItem, modalRepeat, embedType } = this.props;
    onNavigate(false, posts, currentItem, modalRepeat, embedType);
  }

  handleNextClick() {
    const { onNavigate, posts, currentItem, modalRepeat, embedType } = this.props;
    onNavigate(true, posts, currentItem, modalRepeat, embedType);
  }

  render() {
    const { currentItem, itemCount, modalRepeat } = this.props;
    return (
      <div className={styles.modalControls}>
        {(currentItem > 0 || modalRepeat) && (
          <button
            type="button"
            aria-label="show previous"
            className={[styles.modalControl, styles.modalControlBack].join(' ')}
            onClick={this.handlePreviousClick}
          />
        )}
        {(currentItem < itemCount - 1 || modalRepeat) && (
          <button
            type="button"
            aria-label="show next"
            className={[styles.modalControl, styles.modalControlForward].join(' ')}
            onClick={this.handleNextClick}
          />
        )}
      </div>
    );
  }
}

export default ModalControls;
